/*eslint-disable*/
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import { headApi } from "utils/headApi";
import { imgApi } from "utils/imgApi";
import classNames from "classnames";
import Parallax from "components/Parallax/Parallax.js";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Tooltip from "@material-ui/core/Tooltip";
import Close from "@material-ui/icons/Close";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Table from "components/Table/Table.js";
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import BanglesHeader from "views/BanglesPage/Section/BanglesHeader";
import BanglesHeaderLink from "views/BanglesPage/Section/BanglesHeaderLink";
import BanglesFooter from "views/BanglesPage/Section/BanglesFooter";
import SweetAlert from "react-bootstrap-sweetalert";
import profilePageStyle from "assets/jss/material-kit-pro-react/views/profilePageStyle.js";
import invoiceStyle from "assets/jss/material-kit-pro-react/views/invoiceTableStyle";
import listCart from "assets/jss/material-kit-pro-react/views/shoppingCartStyle.js";
import style from "assets/jss/material-kit-pro-react/components/buttonStyle.js";
import basicsCheck from "assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.js";

import Razor from "assets/img/razorpay.png";
import PayTM from "assets/img/paytm.png";
import ICICI from "assets/img/icici.svg";

const useStyles = makeStyles(profilePageStyle);
const useStyleAlert = makeStyles(style);
const useStylesTable = makeStyles(invoiceStyle);
const useStyleCart = makeStyles(listCart);
const useStyle = makeStyles(basicsCheck);

export default function CartView({ ...rest }) {
  const [addCart, setAddCart] = React.useState([]);
  const [userId, setUserId] = React.useState("");
  const [submitted, setSubmitted] = React.useState(false);
  const [alertMsg, alertMsgOps] = React.useState("");
  const [alertType, alertTypeOps] = React.useState("");
  const [submitteds, setSubmitteds] = React.useState(false);
  const [submittedConfirm, setSubmittedConfirm] = React.useState(false);
  const [cardId, setCartId] = React.useState();
  const [payNow, setPayNow] = React.useState(false);
  const [selectedEnabled, setSelectedEnabled] = React.useState("");
  const [submitPayment, setSubmitPayment] = React.useState(false);
  const [load, setLoad] = React.useState(false);

  const classes = useStyles();
  const history = useHistory();
  const classesTable = useStylesTable();
  const classeCart = useStyleCart();
  const classeAlert = useStyleAlert();
  const classe = useStyle();

  const activeSession = sessionStorage.getItem("sessionData");
  const userObj = JSON.parse(sessionStorage.getItem("sessionData"));

  const { state } = useLocation();

  const date = Intl.DateTimeFormat("fr-CA", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  }).format(new Date()).replaceAll('/', '-');

  const current = new Date();
  const dateCurrent = `${current.getDate()}-${current.getMonth() + 1}-${current.getFullYear()}`;
  current.setDate(current.getDate() + 10);
  let dateEx = new Date(current).toLocaleDateString("de");

  async function getList() {
    const get = headApi + `/user/${userObj && userObj.mobile}`;
    const results = await fetch(get);
    const res = await results.json();
    if (res.message === "Mobile Number Not Found") {
      history.push("/error-page");
    }
    setUserId(res.id);
    // const list = headApi + `/cart/byClientid?userid=${res.referenceid}&clientid=${res.id}`
    const list = headApi + `/cart/byInterval?userid=1&clientid=${res.id}`
    const result = await fetch(list);
    const data = await result.json();
    // setAddCart(data.CartData);
    if (data.error === "true") {
      setLoad(false)
      history.push("/error-page");
  } else {
      setLoad(true)
      // setAddCart(data.CartData)
      setAddCart(data && data.CartData ? data.CartData : history.push("/error-page"));
  }
    // console.log(data.CartData);
  }

  useEffect(() => {
    getList();
  }, []);

  const handleitemRemove = (c, submitteds) => {
    setSubmitteds(true)
  }

  const handleConfirm = () => {
    // console.log(cardId);
    axios.delete(headApi + `/cart?id=${cardId}&clientid=${userId}`)
      .then(res => {
        // console.log(res.data);
        // if (res.message === "Data Deleted Successfully!!! ") {
        //   setSubmittedConfirm(true)
        // window.location.reload(false);
        // }
      })
    setSubmittedConfirm(true)
  };

  const AdvancePayRazor = () => {
    var options = {
      key: "rzp_live_SsKrYvXeVM5elD",
      amount: Math.round(totalSum = totalCalMix + totalCal) * 100,
      // amount: Math.round(addCart.reduce((a, b) => a + b.metalOption.metalgram * b.sets.pcs * b.box.box * b.total * b.metal.price, 0)) * 100,
      currency: "INR",
      name: "Sharif H M",
      description: "Insha Bangles",
      handler: function (response) {
        // alert(response.razorpay_payment_id);
        // console.log(response);
        if (response.razorpay_payment_id) {
          setSubmitPayment(true);
          alertTypeOps("success");
          alertMsgOps(`₹ ${Math.round(totalSum = totalCalMix + totalCal) + "/- "} Congratulation your Transaction is Successfully`);
          // alertMsgOps(`₹ 1/- Congratulation your Transaction is Successfully`);
          const cartMid = addCart.map((i) => {
            return i.id;
          })

          cartMid.forEach(x =>
            axios.put(headApi + `/cart/active?id=${x}&clientid=${userObj.id}&active=1`)
              .then(res => {
                // console.log(res.data);
              }))

          const requestOptions = {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              cartid: cartMid[0].toString(),
              cartmultid: cartMid.toString(),
              clientid: userObj.id,
              shippingid: state,
              userid: userObj.referenceid,
              amount: Math.round(addCart.reduce((a, b) => a + b.taxableamt + b.totalcartoncharge, 0)),
              advance: Math.round(totalSum = totalCalMix + totalCal),
              totalbox: addCart.reduce((a, b) => a + b.total, 0),
              totalcarton: addCart.reduce((a, b) => parseInt(a) + parseInt(b.ctnquantity), 0),
              status: 0,
              paymentstatus: 0,
              deliverystatus: 0
            }),
          };

          fetch(
            headApi + "/order",
            requestOptions
          )
            .then((response) => response.json())
            .then((data) => {
              // history.push("/my-order");
              // console.log(data);
              // if (data.message === "Order Placed Successfully !!! ") {
              //   setSubmitted(true);
              //   alertTypeOps("success");
              //   alertMsgOps("Congratulation your Order is Successfully placed");
              //   // history.push("/order-list");
              // }
            });
        }
      },
      prefill: {
        name: userObj.firstname + "" + userObj.lastname,
        email: userObj.email,
        contact: userObj.mobile
      },
      notes: {
        address: "Razorpay Corporate office"
      },
      theme: {
        color: "#528FF0"
      }
    };
    var pay = new window.Razorpay(options);
    pay.open();
  }

  const FullPayRazor = () => {
    var options = {
      key: "rzp_live_SsKrYvXeVM5elD",
      amount: Math.round(addCart.reduce((a, b) => a + b.taxableamt + b.totalcartoncharge, 0)) * 100,
      currency: "INR",
      name: "Sharif H M",
      description: "Insha Bangles",
      handler: function (response) {
        // alert(response.razorpay_payment_id);
        if (response.razorpay_payment_id) {
          setSubmitPayment(true);
          alertTypeOps("success");
          alertMsgOps(`₹ ${Math.round(addCart.reduce((a, b) => a + b.taxableamt + b.totalcartoncharge, 0)) + "/- "} Congratulation your Transaction is Successfully`);
          const cartMid = addCart.map((i) => {
            return i.id;
          })

          cartMid.forEach(x =>
            axios.put(headApi + `/cart/active?id=${x}&clientid=${userObj.id}&active=1`)
              .then(res => {
                // console.log(res.data);
                if (res.data.message === "Cart Updated Successfully!!! ") {
                  setSubmitted(true);
                  alertTypeOps("success");
                  alertMsgOps("Congratulation your Order is Successfully placed");
                }
              }))

          const requestOptions = {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              cartid: cartMid[0].toString(),
              cartmultid: cartMid.toString(),
              clientid: userObj.id,
              shippingid: state,
              userid: userObj.referenceid,
              amount: Math.round(addCart.reduce((a, b) => a + b.taxableamt + b.totalcartoncharge, 0)),
              advance: Math.round(totalSum = totalCalMix + totalCal),
              totalbox: addCart.reduce((a, b) => a + b.total, 0),
              totalcarton: addCart.reduce((a, b) => parseInt(a) + parseInt(b.ctnquantity), 0),
              status: 0,
              paymentstatus: 0,
              deliverystatus: 0
            }),
          };

          fetch(
            headApi + "/order",
            requestOptions
          )
            .then((response) => response.json())
            .then((data) => {
              // history.push("/my-order");
              // console.log(data);
              // if (data.message === "Order Placed Successfully !!! ") {
              //   setSubmitted(true);
              //   alertTypeOps("success");
              //   alertMsgOps("Congratulation your Order is Successfully placed");
              //   // history.push("/order-list");
              // }
            });
        }
      },
      prefill: {
        name: userObj.firstname + "" + userObj.lastname,
        email: userObj.email,
        contact: userObj.mobile
      },
      notes: {
        address: "Razorpay Corporate office"
      },
      theme: {
        color: "#528FF0"
      }
    };
    var pay = new window.Razorpay(options);
    pay.open();
  }

  const confirmOrder = () => {
    const cartMid = addCart.map((i) => {
      return i.id;
    })

    cartMid.forEach(x =>
      axios.put(headApi + `/cart/active?id=${x}&clientid=${userObj.id}&active=1`)
        .then(res => {
          console.log(res.data);
          if (res.data.message === "Cart Updated Successfully!!! ") {
            setSubmitted(true);
            alertTypeOps("success");
            alertMsgOps("Congratulation your Order is Successfully placed");
          }
        }))

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        cartid: cartMid[0].toString(),
        cartmultid: cartMid.toString(),
        clientid: userObj.id,
        shippingid: state,
        userid: userObj.referenceid,
        amount: Math.round(addCart.reduce((a, b) => a + b.taxableamt + b.totalcartoncharge, 0)),
        advance: Math.round(totalSum = totalCalMix + totalCal),
        totalbox: addCart.reduce((a, b) => a + b.total, 0),
        totalcarton: addCart.reduce((a, b) => parseInt(a) + parseInt(b.ctnquantity), 0),
        status: 0,
        paymentstatus: 0,
        deliverystatus: 0
      }),
    };

    fetch(
      headApi + "/order",
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        // history.push("/my-order");
        // console.log(data);
        // if (data.message === "Order Placed Successfully !!! ") {
        //   setSubmitted(true);
        //   alertTypeOps("success");
        //   alertMsgOps("Congratulation your Order is Successfully placed");
        //   // history.push("/order-list");
        // }
      });
  }

  const hideAlert = () => {
    setSubmitted(false);
    history.push("/my-order");
  };

  const hideAlerts = () => {
    setSubmitteds(false);
    setSubmittedConfirm(false);
    window.location.reload(false);
  };

  const hideAlertPayment = () => {
    setSubmitPayment(false);
    history.push("/my-order");
}

  var totalCal = 0;
  var totalCalMix = 0;
  var totalSum = 0;

  return (
    <div>
      <Helmet>
        <title>Cart View</title>
      </Helmet>
      {load ? <>
      <BanglesHeader
        color="info"
        brand="Home"
        links={<BanglesHeaderLink dropdownHoverColor="info" />}
        fixed
        // changeColorOnScroll={{
        //     height: 200,
        //     color: "info",
        // }}
        {...rest}
      />
      <Parallax
        image={require("assets/img/bg6.jpg").default}
        filter="info"
        className={classes.parallax}
      >

      </Parallax>
      <div className={classNames(classeCart.main, classeCart.mainRaised)}>
        <div className={classeCart.container}>
          <Card plain>
            <CardBody plain>
              {submitted ? (
                <SweetAlert
                  type={alertType}
                  style={{ display: "block", marginTop: "100px" }}
                  title={alertMsg}
                  onConfirm={() => hideAlert()}
                  confirmBtnCssClass={
                    classeAlert.button + " " + classeAlert.success
                  }
                />
              ) : null}

              {submitteds ? (
                <SweetAlert
                  warning
                  style={{ display: "block", marginTop: "100px" }}
                  title="Are you sure?"
                  onConfirm={handleConfirm}
                  onCancel={() => hideAlerts()}
                  confirmBtnCssClass={
                    classeAlert.button + " " + classeAlert.success
                  }
                  cancelBtnCssClass={classeAlert.button + " " + classeAlert.danger}
                  confirmBtnText="Yes, delete it!"
                  cancelBtnText="Cancel"
                  showCancel
                />
              ) : null}

              {submittedConfirm ? (
                <SweetAlert
                  success
                  style={{ display: "block", marginTop: "100px" }}
                  title="Deleted!"
                  onConfirm={() => hideAlerts()}
                  onCancel={() => hideAlerts()}
                  confirmBtnCssClass={classeAlert.button + " " + classeAlert.success}
                >
                  Your imaginary file has been deleted.
                </SweetAlert>
              ) : null}

              {submitPayment ? (
                <SweetAlert
                  type={alertType}
                  style={{ display: "block", marginTop: "100px" }}
                  title={alertMsg}
                  onConfirm={() => hideAlertPayment()}
                  confirmBtnCssClass={
                    classeAlert.button + " " + classeAlert.success
                  }
                />
              ) : null}

              <h3 className={classeCart.cardTitle}>Shopping Cart</h3>
              <Table
                tableHead={[
                  <span className={classesTable.tableHead} key="sr">
                    Sr.
                    <br />
                    No.
                  </span>,
                  "",
                  <span className={classesTable.tableHead} key="des">Description of Goods</span>,
                  <span className={classesTable.tableHead + " " + classesTable.headRight} key="qty">
                    Quantity
                  </span>,
                  <span className={classesTable.tableHead + " " + classesTable.headRight} key="pri">
                    Price
                  </span>,
                  <span className={classesTable.tableHead + " " + classesTable.headRight} key="amt">
                    Amount
                  </span>,
                  "",
                ]}
                tableData={[
                  ...addCart.map((c, index) => (
                    [
                      <span className={classesTable.listNumber} key={c.id}>{index + 1}</span>,
                      <div className={classeCart.imgContainer} key={c.id}>
                        {/* Date: {c.timedate.date.slice(0, -12)} */}
                        Date: {new Date(c.timedate.date).toLocaleDateString("de")}
                        {c.design1.img1active === 1 ? (
                          <img
                            src={imgApi + "" + c.design1.image1}
                            alt="..."
                            className={classeCart.img}
                          />
                        ) : c.design2.img2active === 1 ? (
                          <img
                            src={imgApi + "" + c.design2.image2}
                            alt="..."
                            className={classeCart.img}
                          />
                        ) : c.design3.img3active === 1 ? (
                          <img
                            src={imgApi + "" + c.design3.image3}
                            alt="..."
                            className={classeCart.img}
                          />
                        ) : c.design4.img4active === 1 ? (
                          <img
                            src={imgApi + "" + c.design4.image4}
                            alt="..."
                            className={classeCart.img}
                          />
                        ) : c.design5.img5active === 1 ? (
                          <img
                            src={imgApi + "" + c.design5.image5}
                            alt="..."
                            className={classeCart.img}
                          />
                        ) : c.design6.img6active === 1 ? (
                          <img
                            src={imgApi + "" + c.design6.image6}
                            alt="..."
                            className={classeCart.img}
                          />
                        ) : (
                          ""
                        )}
                      </div>,
                      <span key={c.id}>
                        <small className={classesTable.listDescription}>
                          {c.platingList.description.slice(8)} {c.cat.description}{" "}
                          {c.catSize.description}{" / Card id "}{c.id}
                        </small>
                        <br />
                        <small className={classesTable.listDescriptions}>
                          Packing : {c.packing.type}
                        </small>
                        <br />
                        <small className={classesTable.listDescriptions}>
                          {(
                            c.metalOption.readygram * c.sets.pcs +
                            (c?.mixmmList
                              ? c.mixmmList
                                .map((mix) => mix.sets.pcs)
                                .reduce((a, b) => a + b, 0) *
                              c.mixmmList
                                .map((mix) => mix.metalOption.readygram)
                                .reduce((a, b) => a + b, 0)
                              : 0)
                          ).toFixed(4)}{" "}
                          Avg Gram of{" "}
                          {c.sets.pcs +
                            (c?.mixmmList
                              ? c.mixmmList
                                .map((mix) => mix.sets.pcs)
                                .reduce((a, b) => a + b, 0)
                              : 0)}{" "}
                          {c.sets.setdesc.slice(2)}
                        </small>
                        <br />
                        <small className={classesTable.listDescription}>
                          Sets Price :{" "}
                          {c.taxCalculation.cash_gst === 0
                            ? (c.taxCalculation.cash / c.box.box).toFixed(2)
                            : (c.taxCalculation.taxincl / c.box.box).toFixed(2)}
                          /-{" "}
                        </small>
                        <br />
                        <small className={classesTable.listDescriptions}>
                          Metal Rate : ₹ {c.metal.price}/- Advance : ₹{Math.round(c.metalOption.metalgram * c.sets.pcs * c.box.box * c.total * c.metal.price + (c.mixmmList && c.mixmmList ? c.mixmmList.map((m) => m.metalOption.metalgram * m.sets.pcs * m.metal.price).reduce((a, b) => a + b, 0) * c.box.box * c.total : ""))}
                          /-
                        </small>
                        <br />

                        <GridContainer className={classesTable.sizePadding}>
                          {c.stocksizes._1x8 !== 0 ? (
                            <span
                              className={
                                classesTable.textCenter +
                                " " +
                                classesTable.sizeSpan +
                                " " +
                                classesTable.listDescriptionMM
                              }
                            >
                              {c.stocksizes._1x8 === null
                                ? ""
                                : c.stocksizes._1x8 === 0
                                  ? ""
                                  : "1x8"}
                              <br />
                              {c.stocksizes._1x8 === null
                                ? ""
                                : c.stocksizes._1x8 === 0
                                  ? ""
                                  : c.stocksizes._1x8}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.stocksizes._1x10 !== 0 ? (
                            <span
                              className={
                                classesTable.textCenter +
                                " " +
                                classesTable.sizeSpan +
                                " " +
                                classesTable.listDescriptionMM
                              }
                            >
                              {c.stocksizes._1x10 === null
                                ? ""
                                : c.stocksizes._1x10 === 0
                                  ? ""
                                  : c.indiasize === 1
                                    ? "1x10"
                                    : "#1"}
                              <br />
                              {c.stocksizes._1x10 === null
                                ? ""
                                : c.stocksizes._1x10 === 0
                                  ? ""
                                  : c.stocksizes._1x10}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.stocksizes._1x12 !== 0 ? (
                            <span
                              className={
                                classesTable.textCenter +
                                " " +
                                classesTable.sizeSpan +
                                " " +
                                classesTable.listDescriptionMM
                              }
                            >
                              {c.stocksizes._1x12 === null ? (
                                ""
                              ) : c.stocksizes._1x12 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.indiasize === 1 ? "1x12" : "#2"}
                                </span>
                              )}
                              <br />
                              {c.stocksizes._1x12 === null ? (
                                ""
                              ) : c.stocksizes._1x12 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.stocksizes._1x12}
                                </span>
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.stocksizes._1x14 !== 0 ? (
                            <span
                              className={
                                classesTable.textCenter +
                                " " +
                                classesTable.sizeSpan +
                                " " +
                                classesTable.listDescriptionMM
                              }
                            >
                              {c.stocksizes._1x14 === null ? (
                                ""
                              ) : c.stocksizes._1x14 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  1x14
                                </span>
                              )}
                              <br />
                              {c.stocksizes._1x14 === null ? (
                                ""
                              ) : c.stocksizes._1x14 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.stocksizes._1x14}
                                </span>
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.stocksizes._2x0 !== 0 ? (
                            <span
                              className={
                                classesTable.textCenter +
                                " " +
                                classesTable.sizeSpan +
                                " " +
                                classesTable.listDescriptionMM
                              }
                            >
                              {c.stocksizes._2x0 === null ? (
                                ""
                              ) : c.stocksizes._2x0 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.indiasize === 1 ? "2x0" : "#3"}
                                </span>
                              )}
                              <br />
                              {c.stocksizes._2x0 === null ? (
                                ""
                              ) : c.stocksizes._2x0 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.stocksizes._2x0}
                                </span>
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.stocksizes._2x2 !== 0 ? (
                            <span
                              className={
                                classesTable.textCenter +
                                " " +
                                classesTable.sizeSpan +
                                " " +
                                classesTable.listDescriptionMM
                              }
                            >
                              {c.stocksizes._2x2 === null ? (
                                ""
                              ) : c.stocksizes._2x2 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  2x2
                                </span>
                              )}
                              <br />
                              {c.stocksizes._2x2 === null ? (
                                ""
                              ) : c.stocksizes._2x2 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.stocksizes._2x2}
                                </span>
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.stocksizes._2x4 !== 0 ? (
                            <span
                              className={
                                classesTable.textCenter +
                                " " +
                                classesTable.sizeSpan +
                                " " +
                                classesTable.listDescriptionMM
                              }
                            >
                              {c.stocksizes._2x4 === null ? (
                                ""
                              ) : c.stocksizes._2x4 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.indiasize === 1 ? "2x4" : "#4"}
                                </span>
                              )}
                              <br />
                              {c.stocksizes._2x4 === null ? (
                                ""
                              ) : c.stocksizes._2x4 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.stocksizes._2x4}
                                </span>
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.stocksizes._2x6 !== 0 ? (
                            <span
                              className={
                                classesTable.textCenter +
                                " " +
                                classesTable.sizeSpan +
                                " " +
                                classesTable.listDescriptionMM
                              }
                            >
                              {c.stocksizes._2x6 === null ? (
                                ""
                              ) : c.stocksizes._2x6 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  2x6
                                </span>
                              )}
                              <br />
                              {c.stocksizes._2x6 === null ? (
                                ""
                              ) : c.stocksizes._2x6 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.stocksizes._2x6}
                                </span>
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.stocksizes._2x8 !== 0 ? (
                            <span
                              className={
                                classesTable.textCenter +
                                " " +
                                classesTable.sizeSpan +
                                " " +
                                classesTable.listDescriptionMM
                              }
                            >
                              {c.stocksizes._2x8 === null ? (
                                ""
                              ) : c.stocksizes._2x8 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.indiasize === 1 ? "2x8" : "#5"}
                                </span>
                              )}
                              <br />
                              {c.stocksizes._2x8 === null ? (
                                ""
                              ) : c.stocksizes._2x8 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.stocksizes._2x8}
                                </span>
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.stocksizes._2x10 !== 0 ? (
                            <span
                              className={
                                classesTable.textCenter +
                                " " +
                                classesTable.sizeSpan +
                                " " +
                                classesTable.listDescriptionMM
                              }
                            >
                              {c.stocksizes._2x10 === null ? (
                                ""
                              ) : c.stocksizes._2x10 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.indiasize === 1 ? "2x10" : "#6"}
                                </span>
                              )}
                              <br />
                              {c.stocksizes._2x10 === null ? (
                                ""
                              ) : c.stocksizes._2x10 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.stocksizes._2x10}
                                </span>
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.stocksizes._2x12 !== 0 ? (
                            <span
                              className={
                                classesTable.textCenter +
                                " " +
                                classesTable.sizeSpan +
                                " " +
                                classesTable.listDescriptionMM
                              }
                            >
                              {c.stocksizes._2x12 === null ? (
                                ""
                              ) : c.stocksizes._2x12 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.indiasize === 1 ? "2x12" : "#7"}
                                </span>
                              )}
                              <br />
                              {c.stocksizes._2x12 === null ? (
                                ""
                              ) : c.stocksizes._2x12 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.stocksizes._2x12}
                                </span>
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.stocksizes._2x14 !== 0 ? (
                            <span
                              className={
                                classesTable.textCenter +
                                " " +
                                classesTable.sizeSpan +
                                " " +
                                classesTable.listDescriptionMM
                              }
                            >
                              {c.stocksizes._2x14 === null ? (
                                ""
                              ) : c.stocksizes._2x14 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  2x14
                                </span>
                              )}
                              <br />
                              {c.stocksizes._2x14 === null ? (
                                ""
                              ) : c.stocksizes._2x14 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.stocksizes._2x14}
                                </span>
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.stocksizes._3x0 !== 0 ? (
                            <span
                              className={
                                classesTable.textCenter +
                                " " +
                                classesTable.sizeSpan +
                                " " +
                                classesTable.listDescriptionMM
                              }
                            >
                              {c.stocksizes._3x0 === null ? (
                                ""
                              ) : c.stocksizes._3x0 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.indiasize === 1 ? "3x0" : "#8"}
                                </span>
                              )}
                              <br />
                              {c.stocksizes._3x0 === null ? (
                                ""
                              ) : c.stocksizes._3x0 === 0 ? (
                                ""
                              ) : (
                                <span
                                  className={
                                    classesTable.textCenter +
                                    " " +
                                    classesTable.sizeSpan +
                                    " " +
                                    classesTable.listDescriptionMM
                                  }
                                >
                                  {c.stocksizes._3x0}
                                </span>
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                        </GridContainer>
                        <span className={classesTable.listDescription}>{c && c.name ? c.name + ", " : ""} {c && c.mycomment ? c.mycomment : ""}</span>
                      </span>,
                      <span
                        className={classesTable.headRight + " " + classesTable.listNumber}
                        key={c.id}
                      >
                        {c.total}
                      </span>,
                      <span
                        className={classesTable.headRight + " " + classesTable.listNumber}
                        key={c.id}
                      >
                        ₹
                        {c.taxCalculation.cash_gst === 0
                          ? c.taxCalculation.cash
                          : c.taxCalculation.taxincl}
                      </span>,
                      <span
                        className={classesTable.headRight + " " + classesTable.listNumber}
                        key={c.id}
                      >
                        ₹{Math.round(c.taxableamt)}
                      </span>,
                      <Tooltip
                        id="close1"
                        title="Cart Remove"
                        placement="left"
                        classes={{ tooltip: classeCart.tooltip }}
                        key={c.id}
                      >
                        <Button
                          link
                          className={classeCart.actionButton}
                          onClick={() => {
                            handleitemRemove(c.id);
                            setCartId(c.id);
                          }}
                        >
                          <Close style={{ color: "red" }} />
                        </Button>
                      </Tooltip>,
                    ]
                  )),
                  [
                    "",
                    <span className={classesTable.listNumber} key={1}>Cartoon Charges<br />Grand Total</span>,
                    <span className={classesTable.listNumber} key={2}><br />
                      {addCart.map((c) => {
                        totalCal = totalCal + c.metalOption.metalgram * c.sets.pcs * c.box.box * c.total * c.metal.price;
                        // totalSum = totalCal + totalCalMix
                        return (
                          c.mixmmList && c.mixmmList ? c.mixmmList.map((m) => {
                            totalCalMix = totalCalMix + m.metalOption.metalgram * m.sets.pcs * m.metal.price * c.box.box * c.total;
                            totalSum = totalCal + totalCalMix;
                            return (
                              ""
                            )
                          }) : ""
                        )
                      })}
                      Advance - ₹{Math.round(totalSum = totalCalMix + totalCal) + "/-"}</span>,
                    <span key={3}>
                      <span className={classesTable.headRight}>CRTN-{addCart.reduce((a, b) => parseInt(a) + parseInt(b.ctnquantity), 0)}</span><br />
                      <span className={classesTable.headRight + " " + classesTable.listNumber}>Box-{addCart && addCart.reduce((a, b) => a + b.total, 0)}</span>
                    </span>,
                    "",
                    <span key={4}>
                      <span className={classesTable.headRight + " " + classesTable.listNumber}>₹{addCart.reduce((a, b) => a + b.totalcartoncharge, 0) + "/-"}</span><br />
                      <span className={classesTable.headRight + " " + classesTable.listNumber}>₹{Math.round(addCart.reduce((a, b) => a + b.taxableamt + b.totalcartoncharge, 0)) + "/-"}</span>
                    </span>,
                    ""
                  ]
                ]}
              />
              <hr />
              <GridContainer>
                <GridItem md={12} sm={12} xs={12}>
                  <ul>
                    {/* <li>Payment : Advance <span className={classesTable.termDescription}>Rs. {addCart.reduce((a, b) => a + b.metalOption.metalgram * b.sets.pcs * b.box.box * b.total * b.metal.price, 0).toFixed(2)}/-</span> of total amount along with purchase order 20% when dispatchof 1st shipment and Remaining 15% will be payable on confirmation of completion of goods ordered,</li> */}
                    {/* <li>Delivery: 50% of the total goods will be delivered in the first shipment. Remaining 50% will be delivered on the receipt of total outstanding amount of whole purchase order (I.E remaining 15%),</li> */}
                    <li style={{color: "red"}}>Quantity +/- 3% tolerance acceptance.</li>
                                            <li style={{color: "red"}}>Packing and Transportation charges will be extra.</li>
                                            <li style={{color: "red"}}>Insurance covered, if paid 3% of the total purchase.</li>
                    {/* <li>Proposal is valid till <span className={classesTable.termDescription}>{dateEx.replaceAll('.', '-')}</span> from,</li> */}
                  </ul>
                </GridItem>
              </GridContainer>
              <GridContainer style={{ float: "right", marginTop: "15px", marginBottom: "15px" }}>
                <GridItem>
                  <Button color="info" round onClick={confirmOrder}>Confirm Order</Button> &nbsp;&nbsp;
                  <Button color="info" round onClick={() => {
                    setPayNow(true)
                    window.scroll({
                      top: document.body.offsetHeight,
                      left: 0, 
                      behavior: 'smooth',
                    });
                    }}>Pay Now</Button>
                </GridItem>
              </GridContainer>
              <br />
            </CardBody>
          </Card>
        </div>
      </div>
      {payNow === true ?
                    <div className={classes.container}>
                        <GridContainer justify="center" alignItems="center">
                            <GridItem md={12} sm={12}>
                                <Card>
                                    <CardBody>
                                        <GridContainer>
                                            <GridItem md={4} sm={4}><FormControlLabel
                                                control={
                                                    <Radio
                                                        checked={selectedEnabled === "a"}
                                                        onChange={() => setSelectedEnabled("a")}
                                                        value="a"
                                                        name="radio button enabled"
                                                        aria-label="A"
                                                        icon={
                                                            <FiberManualRecord className={classe.radioUnchecked} />
                                                        }
                                                        checkedIcon={
                                                            <FiberManualRecord className={classe.radioChecked} />
                                                        }
                                                        classes={{
                                                            checked: classe.radio,
                                                            root: classe.radioRoot,
                                                        }}
                                                    />
                                                }
                                                classes={{
                                                    label: classe.label,
                                                    root: classe.labelRoot,
                                                }}
                                                label={<img src={Razor} />}
                                            /></GridItem>
                                            <GridItem md={4} sm={4}><FormControlLabel
                                                control={
                                                    <Radio
                                                        checked={selectedEnabled === "b"}
                                                        onChange={() => setSelectedEnabled("b")}
                                                        value="b"
                                                        name="radio button enabled"
                                                        aria-label="B"
                                                        icon={
                                                            <FiberManualRecord className={classe.radioUnchecked} />
                                                        }
                                                        checkedIcon={
                                                            <FiberManualRecord className={classe.radioChecked} />
                                                        }
                                                        classes={{
                                                            checked: classe.radio,
                                                            root: classe.radioRoot,
                                                        }}
                                                    />
                                                }
                                                classes={{
                                                    label: classe.label,
                                                    root: classe.labelRoot,
                                                }}
                                                label={<img src={PayTM} />}
                                            /></GridItem>
                                            <GridItem md={4} sm={4}>
                                                <FormControlLabel
                                                    control={
                                                        <Radio
                                                            checked={selectedEnabled === "c"}
                                                            onChange={() => setSelectedEnabled("c")}
                                                            value="c"
                                                            name="radio button enabled"
                                                            aria-label="C"
                                                            icon={
                                                                <FiberManualRecord className={classe.radioUnchecked} />
                                                            }
                                                            checkedIcon={
                                                                <FiberManualRecord className={classe.radioChecked} />
                                                            }
                                                            classes={{
                                                                checked: classe.radio,
                                                                root: classe.radioRoot,
                                                            }}
                                                        />
                                                    }
                                                    classes={{
                                                        label: classe.label,
                                                        root: classe.labelRoot,
                                                    }}
                                                    label={<img src={ICICI} width={160} />}
                                                /></GridItem>
                                        </GridContainer>
                                        <GridContainer>
                                            {selectedEnabled === "a" ?
                                                <GridItem md={12} sm={12}>
                                                    <Button color="info" round onClick={AdvancePayRazor}>Advance Payment</Button> &nbsp;&nbsp;&nbsp;&nbsp;
                                                    <Button color="info" round onClick={FullPayRazor}>Full Payment</Button>
                                                </GridItem> : selectedEnabled === "b" ?
                                                    <GridItem md={12} sm={12}>
                                                        <Button color="info" round>Advance Payment</Button> &nbsp;&nbsp;&nbsp;&nbsp;
                                                        <Button color="info" round>Full Payment</Button>
                                                    </GridItem> : selectedEnabled === "c" ?
                                                        <GridItem md={12} sm={12}>
                                                            <Button color="info" round>Advance Payment</Button> &nbsp;&nbsp;&nbsp;&nbsp;
                                                            <Button color="info" round>Full Payment</Button>
                                                        </GridItem> : ""}
                                        </GridContainer>
                                    </CardBody>
                                </Card>
                            </GridItem>
                        </GridContainer>
                    </div> : ""}
      <br />
      <BanglesFooter />
      </> : "" }
    </div>
  );
}